
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class Report_1201Dialog extends Serenity.EntityDialog<Report_1201Row, any> {
        protected getFormKey() { return Report_1201Form.formKey; }
        protected getIdProperty() { return Report_1201Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1201Row.localTextPrefix; }
        protected getNameProperty() { return Report_1201Row.nameProperty; }
        protected getService() { return Report_1201Service.baseUrl; }
        protected getDeletePermission() { return Report_1201Row.deletePermission; }
        protected getInsertPermission() { return Report_1201Row.insertPermission; }
        protected getUpdatePermission() { return Report_1201Row.updatePermission; }

        protected form = new Report_1201Form(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }
    }
}